import axios from "axios";
import {StarchDeskeroResponse} from "../interfaces/starch-deskero-response";
import {DeskeroTokenResponse} from "../interfaces/starch-deskero-token-response";
import {City} from "../interfaces/city";
import {StarchApplication} from "../interfaces/starch-application";
import {TicketType} from "../interfaces/ticket-type";
import {DeskeroUserResponse} from "../interfaces/starch-deskero-user-response";
import {StarchTicketCreateResponse} from "../interfaces/starch-ticket-create-response";

export class StarchTicketService {

  apiBase: string;
  accessToken: string;
  clientID: string;

  constructor() {
    this.apiBase = 'https://api.deskero.com/';
  }

  /**
   * Get form config clientID and token
   */
  getConfig() {
    return axios.get<DeskeroTokenResponse>(this.apiBase + 'oauth/token', {
      headers: {
        Authorization:
          'Basic NWNhYjdjZmNlNGIwNDRjN2EzYzE2Yjc1OjZkMTBiMjFlLTk5MzYtNDNhZC1hZTJmLTMxMmQwNTczMGJhYQ=='
      },
      params: {grant_type: 'client_credentials'}
    });
  }

  /**
   * Get cities list
   * @param accessToken Access token
   * @param clientId Client ID
   */

  getCities(name: string): Promise<City[]> {
    return new Promise<City[]>(async (resolve, reject) => {
      try {
        const citiesResponse = await axios.get<StarchDeskeroResponse>(this.apiBase + 'company/list', {
          headers: {
            Authorization: this.accessToken,
            Accept: 'application/json',
            clientID: this.clientID
          },
          params: {
            sort: 'company_ASC',
            text: name,
            page: 1
          }
        });
        resolve(citiesResponse.data.company.records);
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * Get applications list
   * @param accessToken Access token
   * @param clientId Client ID
   */
  getApplications(): Promise<StarchApplication[]> {
    return new Promise<StarchApplication[]>(async (resolve, reject) => {
      try {
        const applicationsResponse = await axios.get<StarchDeskeroResponse>(this.apiBase + 'ticketGroup/list', {
          headers: {
            Authorization: this.accessToken,
            Accept: 'application/json',
            clientID: this.clientID
          }
        });
        resolve(applicationsResponse.data.group.records);
      } catch (e) {
        reject(e);
      }
    });
  }

  getStarchApplicationId(groupName: string): Promise<StarchDeskeroResponse> {
    groupName = groupName.replace(/ /g, '_');
    groupName = groupName.replace(/\./g, '_');
    return new Promise<StarchDeskeroResponse>(async (resolve, reject) => {
      try {
        const applicationIdResponse = await axios.get<StarchDeskeroResponse>(
          this.apiBase + 'ticketGroup/list?groupName=' + groupName,
          {
            headers: {
              Authorization: this.accessToken,
              Accept: 'application/json',
              clientID: this.clientID
            }
          });
        console.log('ID response', applicationIdResponse);
        resolve(applicationIdResponse.data);
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  }

  getErrorTypes(): Promise<TicketType[]> {
    return new Promise<TicketType[]>(async (resolve, reject) => {
      try {
        const errorTypeResponse = await axios.get<StarchDeskeroResponse>(this.apiBase + 'ticketType/list', {
          headers: {
            Authorization: this.accessToken,
            Accept: 'application/json',
            clientID: this.clientID
          }
        });
        resolve(errorTypeResponse.data.type.records);
      } catch (e) {
        reject(e);
      }
    });
  }

  checkUserMail(userEmail: string) {
    return new Promise<DeskeroUserResponse>(async (resolve, reject) => {
      try {
        const checkUserMailResponse = await axios.get<DeskeroUserResponse>(this.apiBase + 'customer/list', {
          headers: {
            Authorization: this.accessToken,
            Accept: 'application/json',
            clientID: this.clientID
          },
          params: {email: userEmail}
        });
        resolve(checkUserMailResponse.data);
      } catch (e) {
        reject(e);
      }
    });
  }

  createDeskeroUser(body: {}): Promise<DeskeroUserResponse> {
    return new Promise<DeskeroUserResponse>(async (resolve, reject) => {
      try {
        const createUserResponse = await axios.post<DeskeroUserResponse>(this.apiBase + 'customer/insert', body, {
          headers: {
            Authorization: this.accessToken,
            'Content-Type': 'application/json',
            clientID: this.clientID
          }
        });
        resolve(createUserResponse.data)
      } catch (e) {
        reject(e);
      }
    });
  }

  createTicket(ticket: any): Promise<StarchTicketCreateResponse> {
    return new Promise<StarchTicketCreateResponse>(async (resolve, reject) => {
      try {
        const createTicketResponse = await axios.post<StarchTicketCreateResponse>(this.apiBase + 'ticket/insert?sendNotifications=true', ticket, {
          headers: {
            Authorization: this.accessToken,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            clientID: this.clientID
          }
        });
        resolve(createTicketResponse.data);
      } catch (e) {
        reject(e);
      }
    });
  }

  getTicketDetails(id: string) {
    return new Promise<any>(async resolve => {
      const errorTypeResponse = await axios.get<StarchDeskeroResponse>(this.apiBase + 'ticket/' + id, {
        headers: {
          Authorization: this.accessToken,
          Accept: 'application/json',
          clientID: this.clientID
        }
      });
      resolve(errorTypeResponse.data);
    });
  }

  getEnabledCodcat(): string[] {
    // return ['DEM2'];
    return ['DEM2', 'B157', 'D045', 'C952', 'L312', 'D231', 'A849', 'H355', 'A652', 'D891', 'A163', 'A163', 'H122', 'C443', 'L929', 'A215', 'L682', 'G087', 'D019', 'G687', 'C732', 'D707', 'L704', 'I873', 'L667', 'G686', 'D940'];
  }
}
